'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dSite$002dName$0024$0024anon$0024115 from "./presto.types$-Site-Name$$anon$115.js";
import * as $j_presto$002etypes$0024$002dSite$002dName$0024$0024anon$0024116 from "./presto.types$-Site-Name$$anon$116.js";
var $p;
/** @constructor */
function $c_Lpresto_types$SiteName$() {
  this.cck = null;
  this.ccl = false;
  this.cci = null;
  this.ccj = false;
  this.cco = null;
  this.ccp = false;
  this.ccm = null;
  this.ccn = false;
  this.ccq = null;
  this.ccr = false;
}
export { $c_Lpresto_types$SiteName$ as $c_Lpresto_types$SiteName$ };
$p = $c_Lpresto_types$SiteName$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$SiteName$;
/** @constructor */
function $h_Lpresto_types$SiteName$() {
}
export { $h_Lpresto_types$SiteName$ as $h_Lpresto_types$SiteName$ };
$h_Lpresto_types$SiteName$.prototype = $p;
$p.cJl = (function() {
  if ((!this.ccl)) {
    this.cck = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().aC;
    this.ccl = true;
  }
  return this.cck;
});
$p.iU = (function() {
  if ((!this.ccj)) {
    this.cci = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().a9;
    this.ccj = true;
  }
  return this.cci;
});
$p.aee = (function() {
  if ((!this.ccp)) {
    this.cco = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lcom_raquo_laminar_modifiers_RenderableText$$anon$1(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((x) => x)), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_modifiers_RenderableText$());
    this.ccp = true;
  }
  return this.cco;
});
$p.To = (function() {
  if ((!this.ccn)) {
    this.ccm = new $j_presto$002etypes$0024$002dSite$002dName$0024$0024anon$0024115.$c_Lpresto_types$SiteName$$anon$115(this);
    this.ccn = true;
  }
  return this.ccm;
});
$p.cKa = (function() {
  if ((!this.ccr)) {
    this.ccq = new $j_presto$002etypes$0024$002dSite$002dName$0024$0024anon$0024116.$c_Lpresto_types$SiteName$$anon$116(this);
    this.ccr = true;
  }
  return this.ccq;
});
var $d_Lpresto_types$SiteName$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$SiteName$, "presto.types$SiteName$", ({
  a1X: 1,
  D: 1
}));
export { $d_Lpresto_types$SiteName$ as $d_Lpresto_types$SiteName$ };
var $n_Lpresto_types$SiteName$;
function $m_Lpresto_types$SiteName$() {
  if ((!$n_Lpresto_types$SiteName$)) {
    $n_Lpresto_types$SiteName$ = new $c_Lpresto_types$SiteName$();
  }
  return $n_Lpresto_types$SiteName$;
}
export { $m_Lpresto_types$SiteName$ as $m_Lpresto_types$SiteName$ };
//# sourceMappingURL=presto.types$-Site-Name$.js.map
